import moment from 'moment'

export const handleSelectAllClick = (event, setSelected, invoices) => {
  if (event.target.checked) {
    setSelected(invoices)
    return
  }
  setSelected([])
}

export const isSelected = (id, selected) =>
  selected.findIndex(x => x.id === id) !== -1

export const handleSelectClick = (event, item, selected, setSelected) => {
  const selectedIndex = selected.findIndex(x => x.id === item.id)
  let newSelected = []

  if (selectedIndex === -1) {
    newSelected = newSelected.concat(selected, item)
  } else if (selectedIndex === 0) {
    newSelected = newSelected.concat(selected.slice(1))
  } else if (selectedIndex === selected.length - 1) {
    newSelected = newSelected.concat(selected.slice(0, -1))
  } else if (selectedIndex > 0) {
    newSelected = newSelected.concat(
      selected.slice(0, selectedIndex),
      selected.slice(selectedIndex + 1),
    )
  }

  setSelected(newSelected)
}

export const formatDate = date => moment(date).format('MMM DD YYYY')
